import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {en_US, NZ_I18N} from 'ng-zorro-antd/i18n';
import {registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import {LoginModule} from './pages/login/login.module';
import {LayoutModule} from './pages/layout/layout.module';
import {GraphQLModule} from './graphql.module';
import {AppErrorHandler} from './@core/app-error-handler';
import {GraphqlInterceptor} from './@core/graphql.interceptor';
import {NzMessageService} from 'ng-zorro-antd/message';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {RouteReuseStrategy} from '@angular/router';
import {AppRouteCache} from './@core/app-route-cache';
import {JwtAuthClient} from './@core/jwt-auth-client.service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {MonacoEditorModule} from 'ngx-monaco-editor-v2';
import {NgxEchartsModule} from 'ngx-echarts';

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LoginModule,
    LayoutModule,
    GraphQLModule,
    MonacoEditorModule.forRoot(),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    })], providers: [
    NzMessageService,
    NzModalService,
    NzNotificationService,
    JwtAuthClient,
    {provide: NZ_I18N, useValue: en_US},
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GraphqlInterceptor,
      multi: true,
    },
    {provide: RouteReuseStrategy, useClass: AppRouteCache},
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule {
}
